import style from './streamingRoom.module.scss';
import AlertIcon from './img/alert.svg';

export const notEnoughModal = {
    title: <div className={style.warningModal__title}>
        <AlertIcon />
        <p>鑽石餘額不足</p>
    </div>,
    content: <p className={style.warningModal__content}>鑽石餘額不足，立即儲值以獲得更多精彩！</p>,
    confirmText: "前往儲值",
    backdropClickMode: false,
    boxStyle: { bgcolor: "#262626" }
}

export const notEnoughWarningModal = {
    title: <div className={style.warningModal__title}>
        <AlertIcon />
        <p>鑽石快沒囉</p>
    </div>,
    content: <p className={style.warningModal__content}>鑽石快沒囉！
        別錯過我的壞壞秘密表演～
        立即補充，別錯過壞壞的每一刻！</p>,
    confirmText: "前往儲值",
    cancelText: "再等等",
    backdropClickMode: false,
    boxStyle: { bgcolor: "#262626", gap: "1rem" }
}

export const defaultAvatar = "https://assets.dev.whywhy.pro/default/default-avatar.png";
